import React from 'react'
import ChatBody from './ChatBody'
import ChatFooter from './ChatFooter'
import axios from 'axios'

const {
    REACT_APP_DATABASE_BASEURL_DEV,
    REACT_APP_DATABASE_BASEURL,
    REACT_APP_NODE_ENV
} = process.env;

const PM = ({
    modalTitle,
    generateHeaderCloseIco,
    socket,
    toRoom,
    toWho,
    users,
    currUser,
    me,
    generateCreatedAt,
    userSuspended,
    handleCloseAndDisableSidebarRight
}) => {

    const [userBlocked, setUserBlocked] = React.useState(false)
    const [amIBlocked, setAmIBlocked] = React.useState(false)

    React.useEffect(() => {
        isChatBlocked()
    }, [])

    React.useEffect(() => {
        // Listen for when another user blocks you
        socket.on('chatClosedByBlock', ({ blocker }) => {
            setAmIBlocked(true);        
        });

        socket.on('chatUnblocked', ({ blocker }) => {
            setAmIBlocked(false);        
        });

         return () => {
            socket.off('chatClosedByBlock');
            socket.off('chatUnblocked');
        };
    }, [socket]);

    const isChatBlocked = async () => {

        try {
            const response = await axios.post(
                `${REACT_APP_NODE_ENV === 'development' ?
                    REACT_APP_DATABASE_BASEURL_DEV :
                    REACT_APP_DATABASE_BASEURL}/user-name/${currUser}`, {
                attributes: ['blockedUsers']
            })
            if (response.data.status === 1) {
                const didIBlockThisUser = response.data.user.blockedUsers.findIndex((u) => { return u === toWho })
                setUserBlocked(didIBlockThisUser === -1 ? false : true)
            }
        } catch (e) {
            console.log('error')
        }

        try {
            const response = await axios.post(
                `${REACT_APP_NODE_ENV === 'development' ?
                    REACT_APP_DATABASE_BASEURL_DEV :
                    REACT_APP_DATABASE_BASEURL}/user-name/${toWho}`, {
                attributes: ['blockedUsers']
            })
            if (response.data.status === 1) {
                const didThisUserBlockMe = response.data.user.blockedUsers.findIndex((u) => { return u === currUser })
                setAmIBlocked(didThisUserBlockMe === -1 ? false : true)
            }
        } catch (e) {
            console.log('error')
        }
    }

    return (
        <div className="pop-up">
            <div className="pop-up-content">
                <div className="pop-up__title">
                    <div className="pop-up__title__content">
                        {modalTitle}
                        {generateHeaderCloseIco()}
                    </div>
                </div>
                <div className="modal-content-wrapper">
                    <ChatBody generateCreatedAt={generateCreatedAt} currUser={currUser} socket={socket} pm={true} room={toRoom} to={toWho} from={currUser} users={users} />
                </div>
            </div>
            {amIBlocked && userBlocked ? (
                <div className="w100 padding20">
                    <p className="margin-left-20 margin-bottom">Blokirali ste jedan drugoga.</p>
                </div>
            ) : userBlocked ? (
                <div className="w100 padding20">
                    <p className="margin-left-20 margin-bottom">Blokirao si korisnika</p>
                </div>
            ) : amIBlocked ? (
                <div className="w100 padding20">
                    <p className="margin-left-20 margin-bottom">Korisnik te je blokirao</p>
                </div>
            ) : (
                <ChatFooter
                    handleCloseAndDisableSidebarRight={handleCloseAndDisableSidebarRight}
                    userSuspended={userSuspended}
                    socket={socket}
                    pm={true}
                    to={toWho}
                    room={toRoom}
                    me={me}
                />
            )}
        </div>
    )
}

export default PM